import { render, staticRenderFns } from "./DelePortal.vue?vue&type=template&id=3c15c4a0&scoped=true&"
import script from "./DelePortal.vue?vue&type=script&lang=js&"
export * from "./DelePortal.vue?vue&type=script&lang=js&"
import style0 from "./DelePortal.vue?vue&type=style&index=0&id=3c15c4a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c15c4a0",
  null
  
)

export default component.exports